<script></script>

<template>
  <svg
    viewBox="0 0 64 65"
    class="w-16 h-16 text-purple-300"
  >
    <path
      d="M34.9004 9.64648L57.3535 32.1104L57.7061 32.4639L57.3545 32.8174L34.9004 55.3525L34.5479 55.707L34.1934 55.3545L28.7412 49.917L28.3887 49.5645L28.7393 49.2109L41.0918 36.7578L7.00098 36.8271L6.5 36.8281V28.1006H41.0166L28.7402 15.79L28.3877 15.4365L28.7412 15.083L34.1934 9.64551L34.5469 9.29297L34.9004 9.64648Z"
      stroke="currentColor"
      fill="transparent"
      class="animation group-hover:opacity-0"
    />
    <path
      d="M28.2812 10.8871L35.2597 4L64 32.4547L35.2597 61L28.2812 54.1129L45.1765 37.2575L0 37.3482V27.5612H45.0846L28.2812 10.8871Z"
      fill="currentColor"
      class="opacity-0 animation group-hover:opacity-100"
    />
  </svg>
</template>
